function sidebarTemplate(active) {
	return Helper.template.sidebarNav([
		{
			content: `<span class="list-label"><i class="ph ph-tree-structure"></i> Areas Tree</span>`,
			route: "/#!/areas/tree",
			is_active: active == "areas-tree"
		},
		{
			content: `<span class="list-label"><i class="ph ph-star"></i> Favorites</span>`,
			route: "/#!/areas/favorites",
			is_active: active == "areas-favorites"
		}
	]);
}

export {
	sidebarTemplate
}